export const ConsumerEditPhoneNumberSectionViewStyles = {
  updatePhoneForm:
    'w-full pb-6 flex flex-col lcpq-flex-1-0-auto sm:py-6 sm:w-auto',
  title:
    'font-bold text-16px text-blue700 text-center mt-6 sm:text-20px sm:mt-12 sm:font-normal',
}
